import script from "./CatalogPublication.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogPublication.vue?vue&type=script&setup=true&lang=js"

import "./CatalogPublication.vue?vue&type=style&index=0&id=5059f974&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5059f974"]])

export default __exports__